import { COLOR_TEXT_MAIN } from '../../../../theme/colors';

const ClickTrackingIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 35" fill={COLOR_TEXT_MAIN} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.2205 35C10.8107 35 10.425 34.9218 10.0634 34.7653C9.70181 34.6088 9.38843 34.3981 9.12327 34.1333L2 27.0556L2.86781 26.1528C3.15708 25.8639 3.45238 25.6773 3.7537 25.5931C4.05502 25.5088 4.41058 25.5028 4.82038 25.575L9.41254 26.3694V11.5278C9.41254 10.8056 9.6536 10.2037 10.1357 9.72222C10.6178 9.24074 11.2205 9 11.9436 9C12.6668 9 13.2695 9.24074 13.7516 9.72222C14.2337 10.2037 14.4748 10.8056 14.4748 11.5278V19.4722H14.8363C15.1497 19.4722 15.4872 19.5083 15.8488 19.5806C16.2104 19.6528 16.5599 19.7731 16.8974 19.9417L22.2127 22.2889C22.8877 22.5778 23.3758 23.0472 23.6772 23.6972C23.9785 24.3472 24.0689 25.0454 23.9483 25.7917L22.719 32.6167C22.5984 33.3148 22.2609 33.8866 21.7065 34.3319C21.1521 34.7773 20.5253 35 19.8263 35H11.2205Z"
      fill="#4C566C"
    />
    <rect x="11" width="2" height="7" rx="1" fill="#4C566C" />
    <rect x="18.5352" y="4" width="2" height="5" rx="1" transform="rotate(45 18.5352 4)" fill="#4C566C" />
    <rect x="7.53516" y="15" width="2" height="5" rx="1" transform="rotate(45 7.53516 15)" fill="#4C566C" />
    <rect x="4" y="5.41406" width="2" height="5" rx="1" transform="rotate(-45 4 5.41406)" fill="#4C566C" />
    <rect x="17" y="11" width="7" height="2" rx="1" fill="#4C566C" />
    <rect y="11" width="7" height="2" rx="1" fill="#4C566C" />
  </svg>
);

export default ClickTrackingIcon;
